export default __webpack_public_path__ + "static/media/telasespeciais.9e3fab64.png";